/*
 * View for the topic label modal
 */

define(["jquery", "marionette", "./template/touchpointMapTemplate.html"], function (
  $,
  Marionette,
  TouchpointMapTemplate,
) {
  "use strict";

  const TouchpointMapView = {};

  TouchpointMapView.touchpointMapView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: TouchpointMapTemplate,
    events: {
      "click .chkDeleteTouchpoint": function (e) {
        const touchpointId = this._getTouchpointId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:touchpoint:allowDelete", touchpointId);
      },
      "click .chkEditTouchpoint": function (e) {
        const touchpointId = this._getTouchpointId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:touchpoint:allowEdit", touchpointId);
      },
      "click .chkViewTouchpoint": function (e) {
        const touchpointId = this._getTouchpointId(e);
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:touchpoint:allowView", touchpointId);
      },
    },
    _getTouchpointId: function (e) {
      //get the intent id of the topic by getting the custom data attribute
      const touchpointId = $(e.target).attr("data-touchpointId");
      //force it to be a number
      return +touchpointId;
    },
  });

  return TouchpointMapView;
});
